module.exports = __webpack_public_path__ + "static/american-optometric-association-da2f9bbb629ad66fff138079877918e5.png";